import api from './api';

export interface PlanType {
    id: number;
    value: string;
    label: string;
    name: string;
    price: number;
    billing_cycle: string;
    monthly_price: number;
    yearly_price: number;
    description: string;
}

export interface SubscriptionRequest {
    plan_id: number;
    billing_type: 'monthly' | 'yearly';
    payment_method: string;
    user: number; // ID del usuario
    end_date: string; // Fecha en formato ISO
}

export const getPlans = async (): Promise<PlanType[]> => {
    try {
        const response = await api.get('/api/plans/');
        return response.data;
    } catch (error) {
        console.error('Error al obtener los planes:', error);
        throw new Error('Error al obtener los planes');
    }
};

export const subscribeToPlan = async (subscriptionData: SubscriptionRequest) => {
    try {
        const response = await api.post('/api/subscriptions/', subscriptionData);
        return response.data;
    } catch (error) {
        console.error('Error al procesar la suscripción:', error);
        throw error;
    }
};

export const getCurrentUser = async () => {
    try {
        const response = await api.get('/api/get_user/');
        return response.data;
    } catch (error) {
        console.error('Error al obtener el usuario actual:', error);
        throw error;
    }
};

export const getSubscribeCurrentPlan = async () => {
    try {
        const response = await api.get('/api/subscriptions/');
        return response.data[0];
    } catch (error) {
        console.error('Error al procesar la suscripción:', error);
        throw error;
    }
};